<template>
  <div class="component-upload-image">
    <el-upload :action="this.isWatermark?uploadFileAddWatermark:uploadImgUrl" :accept="limitType" :multiple="limit > 1" :limit="limit" :headers="headers" :on-success="handleUploadSuccess" :before-upload="handleBeforeUpload" :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" :on-exceed="handleExceed" :file-list="value">
      <el-button size="small" type="primary">{{fileTxt}}</el-button>
      <span class="hint" v-if="hintText"><br />{{hintText}}</span>
    </el-upload>
  </div>
</template>

<script>
import { UploadFile, uploadSinglePath } from '@/api/_user';
import { getToken } from '@/utils/auth'
export default {
  data() {
    return {
      dialogVisible: false,
      uploadFileAddWatermark: process.env.VUE_APP_BASE_API + '/sys/cosUploader/uploadFileAddWatermark',
      uploadImgUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload', // 上传的图片服务器地址
      headers: {
        token: 'DU ' + getToken()
      }

    };
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    fileTxt: {
      type: String,
      default: "点击上传",
    },
    limit: {
      type: Number,
      default: 1,
    },
    isWatermark: {
      type: Number,
      default: 0,
    },
    hintText: {
      type: String,
      default: "",
    },
    limitType: {
      type: String,
      default: "",
    }
  },
  created() {
  },
  methods: {
    handleRemove(file, fileList) {
    },
    handlePreview(file) {
    },
    handleUploadSuccess(res) {
      if (res.code === '0') {
        this.value.push({ url: res.data, name: res.data })
        this.$emit("input", this.value);
      } else {
        // 视频上传失败提示
        this.$message({
          type: "error",
          message: "视频上传失败",
        });
      }
    },
    handleBeforeUpload(file) {
      // 检查文件大小是否超过300MB
      const fileSizeMB = file.size / 1024 / 1024
      if (fileSizeMB > 300) {
        // 显示确认弹窗
        return new Promise((resolve) => {
          this.$confirm('视频过大，容易上传失败，是否继续？', '提示', {
            confirmButtonText: '继续',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // 用户选择继续，允许上传
            resolve(true)
          }).catch(() => {
            // 用户选择取消，阻止上传
            resolve(false)
          })
        })
      }
      return true // 文件大小未超过300MB，允许上传
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      this.$emit("input", []);
    }
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.image {
  position: relative;
}
.image .mask {
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: all 0.3s;
}
.image:hover .mask {
  opacity: 1;
}
.hint {
  font-size: 12px;
  color: #9b9c9d;
  line-height: 16px;
  padding-left: 10px;
}
::v-deep .el-upload {
  text-align: left;
  display: flex;
}
</style>